import React, { useEffect, useState } from 'react';
import { Table, Button, Row, Col, notification, Select } from 'antd';
import { IoMdDocument, IoMdCalendar } from "react-icons/io";
import { RiFileExcel2Fill } from "react-icons/ri";
import { getAcc } from '../services/accountService';
import { getAccMov } from '../services/accountingMovementService';
import ReactExport from "react-export-excel";
import moment from 'moment';
import { dateFormat } from "../config.json";

import ModalFecha from './ModalFecha';

const { Option } = Select;
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function AccountingMovement(){
  const[dataTableCompleta, setDataTableCompleta] = useState([]);
  const[tableLoading, setTableLoading] = useState(false);
  const[accountLoading, setAccountLoading] = useState(false);
  const[dataAccount, setDataAccount] = useState([]);
  const[modalVisibleFecha, setModalVisibleFecha] = useState(false);
  const[selectedAccounts, setSelectedAccounts] = useState([]);
  const[selectedFechas, setSelectedFechas] = useState([]);
  const[btnExcelVisible, setBtnExcelVisible] = useState(false);
  

    useEffect(() => {
        async function accounts(){
            setAccountLoading(true);
            const request = {
                "Accounts" : []
            }
            const { data } = await getAcc(request);
            setDataAccount(data);
            setAccountLoading(false);
        }
        accounts();
        
    },[])

    const msNotification = (type, title, desc) => {
      notification[type]({
        message: title,
        description:
          desc,
      });
    };

    function handleChangeAccounts(value) {
        setSelectedAccounts(value);
        
    }

    const handleClickModalFecha = () =>{
        setModalVisibleFecha(true);
    }

    const handleCancelModalFecha = () =>{
        setModalVisibleFecha(false);
      }
  
      const handleOkModalFecha = (data) =>{
        const dataUTC = [];      
        for (let i = 0; i < data.length; i++) {
          const elementUTC = data[i];

          if(elementUTC.high != null){
            let fecha = elementUTC.low.split("/");
            let newDate = new Date(fecha[2]+"-"+fecha[1]+"-"+fecha[0]+" 00:00:00");
            let fecha2 = elementUTC.high.split("/");
            let newDate2 = new Date(fecha2[2]+"-"+fecha2[1]+"-"+fecha2[0]+" 00:00:00");
            dataUTC.push({
              key: dataUTC.length+1,
              option: elementUTC.option,
              sign: elementUTC.sign,
              low: newDate,
              high: newDate2
            });
          }else{
            let fecha = elementUTC.low.split("/");
            let newDate = new Date(fecha[2]+"-"+fecha[1]+"-"+fecha[0]+" 00:00:00");
            dataUTC.push({
              key: dataUTC.length+1,
              option: elementUTC.option,
              sign: elementUTC.sign,
              low: newDate,
              high: null
            });
          }
          
        }
        setSelectedFechas(dataUTC);
        setModalVisibleFecha(false);
      }

    const handleClickReport = async () =>{
      setDataTableCompleta([]);
      setBtnExcelVisible(false);
      const request = {
        "Accounts" : selectedAccounts,
        "DateRange" : selectedFechas
      }
      setTableLoading(true);
      async function getReport(){
        const { data } = await getAccMov(request);
        if(data.length === 0){
          msNotification('info', 'Reporte', 'No se encontraron datos con los filtros seleccionados.' );
          setTableLoading(false);
          return false;
        }else{
          setBtnExcelVisible(true);
        }

        const dataModel = [];
        let indx = 1;
        for (let x = 0; x < data.length; x++) {
          const header = data[x];
          if(header.accountingDetails.length > 0){
            for (let y = 0; y < data[x].accountingDetails.length; y++) {
              
              const detail = data[x].accountingDetails[y];
              dataModel.push({
                key: indx,
                id: Number(header.id),
                customer: header.customer,
                organization: header.organization,
                movementType: header.movement.movementType,
                user: header.user,
                date: header.date,
                accountPosition: detail.account.id,
                accountName: detail.account.name,
                accountValue: detail.account.value,
                debitCreditIndicator: detail.debitCreditIndicator,
                accountingValue: detail.value,
                month: header.month,
                year: header.year,
              });
              indx++;
            }
          }
        }
        let dataOrder = dataModel.sort(function(a,b){
          return a.id - b.id;
        });
        
        setDataTableCompleta(dataOrder);
        setTableLoading(false);
      }
      getReport();
    }

    const formatDate = (current_datetime)=>{
      let formatted_date = moment.utc(current_datetime).local().format(dateFormat);
      return formatted_date;
    }

    const formatNumber = (number)=>{
      let imp = ((number * 100) / 100).toFixed(2);
      return imp;
    }
    

    const rowClassColor = (record, index) => record.accountValue >= 0 ? 'rowGreen' : 'rowRed';

    const columnsComplete = [
      {
        title: 'ID',
        dataIndex: 'id',
        fixed: 'left'
      },
      {
        title: 'Movimiento',
        dataIndex: 'movementType',
        render: (value) => (value.id + " - " + value.name)
      },
      {
        title: 'Posición',
        dataIndex: 'accountPosition',
        render: (value) => (value)
      },
      {
        title: 'Cuenta',
        dataIndex: 'accountName',
        render: (value) => (value)
      },
      {
        title: 'Importe',
        dataIndex: 'accountingValue',
        render: (value) => (`$ ${formatNumber(value)}`)
      },
      {
        title: 'Indicador D/C',
        dataIndex: 'debitCreditIndicator',
        render: (value) => (value)
      },
      {
        title: 'Mes',
        dataIndex: 'month',
        render: (value) => (value)
      },
      {
        title: 'Año',
        dataIndex: 'year',
        render: (value) => (value)
      },
      {
        title: 'Fecha',
        dataIndex: 'date',
        render: (value) => (formatDate(value))
      },
      {
        title: 'Usuario',
        dataIndex: 'user',
        render: (value) => (value.userName)
      },
      
    ];
    
    

    return(
      <div className="mainContainer">
        <ModalFecha modalVisibleFecha={modalVisibleFecha} 
        handleCancelModalFecha={handleCancelModalFecha}
        handleOkModalFecha={handleOkModalFecha}/>

        <Row>
            <Col span={24}>
                <h1 className="title">Reporte de movimientos contables</h1>
                <hr className="hr-title"/>
            </Col>
        </Row>

        <Row className="detailContainer">
          <Col span={20}></Col>
          <Col span={4}>
            <div className="">
              <Button block type="primary" icon={<IoMdDocument/>} onClick={handleClickReport}>
                &nbsp; Generar
              </Button>
            </div>
          </Col>
          <Col span={24}><br /></Col>

          <Col span={8}>
            <div className="">
              <Button block type="primary" icon={<IoMdCalendar/>} onClick={handleClickModalFecha}>
                &nbsp; Fechas...
              </Button>
            </div>
          </Col>
          <Col span={2}></Col>
          <Col span={8}>
            <Select mode="multiple" loading={accountLoading} style={{ width: '100%' }} 
              onChange={handleChangeAccounts} 
              placeholder="Cuentas..."
              maxTagCount='responsive'>
                {dataAccount.map(function(obj){
                    return <Option key={obj.id} value={obj.id}>{obj.name}</Option>
                })}
            </Select>
          </Col>
          <Col span={6}></Col>
          <Col span={24}><br /></Col>
          
          <Col span={24}>
            <Row>
                <Col span={24}><br /></Col>
                <Col span={6} className={"collapse" + (btnExcelVisible ? 'in' : '')}>
                <ExcelFile filename="Reporte-Movimientos-Contables" element={<Button block type="primary" icon={<RiFileExcel2Fill/>}> Descargar datos</Button>}>
                    <ExcelSheet data={dataTableCompleta} name="Movimientos contables">
                        <ExcelColumn label="ID" value={(col) => col.id}/>
                        <ExcelColumn label="Movimiento" value={(col) => col.movementType.id + " - " + col.movementType.name}/>
                        <ExcelColumn label="Posición" value={(col) => col.accountPosition}/>
                        <ExcelColumn label="Cuenta" value="accountName"/>
                        <ExcelColumn label="Importe" value={(col) => `$ ${formatNumber(col.accountingValue)}`}/>
                        <ExcelColumn label="Indicador D/C" value="debitCreditIndicator"/>
                        <ExcelColumn label="Mes" value={(col) => col.month}/>
                        <ExcelColumn label="Año" value="year"/>
                        <ExcelColumn label="Fecha" value="date"/>
                        <ExcelColumn label="Usuario" value={(col) => col.user.userName}/>
                    </ExcelSheet>
                    
                </ExcelFile>
                </Col>
                <Col span={24}>
                <br/>
                <Table rowKey="key" dataSource={dataTableCompleta} columns={columnsComplete} 
                    loading={tableLoading} scroll={{ x:'auto' }}
                    rowClassName={rowClassColor}/>
                </Col>
            </Row>
          </Col>
              
        </Row>
      </div>
    );
}

export default AccountingMovement;



// WEBPACK FOOTER //
// ./src/components/AccountingMovement.jsx